/**
 * Analytics — thin wrappers around window.gtag so callers don't have to
 * null-check the tag or repeat the send_to conversion ID.
 *
 * The base gtag.js snippet lives in /public/index.html and is loaded once
 * per SPA session; these helpers fire specific events after key funnel
 * moments (signup, purchase, etc). All calls are safe if gtag is missing
 * (ad-blockers, offline, native web view without JS ads) — they no-op.
 */

// Google Ads conversion IDs. Keep any new conversions in this map so we
// have a single source of truth (labels come from the Google Ads UI:
// Tools → Measurement → Conversions → New conversion → Tag setup).
const CONVERSIONS = {
    signup: "AW-18328595320/65N7CMzdydgcEPjW4KNE",
};

function safeGtag(...args) {
    if (typeof window === "undefined") return;
    const g = window.gtag;
    if (typeof g !== "function") return;
    try {
        g(...args);
    } catch (e) {
        // Don't let ad-tag errors break user flow.
        console.warn("[analytics] gtag call failed", e);
    }
}

/**
 * Fire the Google Ads signup conversion. Call ONLY on first-account
 * creation — not on every login. Safe to call more than once (Google
 * dedupes on their side by transaction_id if provided, but our funnel
 * naturally only hits this per session).
 *
 * @param {object} opts
 * @param {number} [opts.value=1.0] – conversion value in CAD.
 * @param {string} [opts.transactionId] – optional dedupe key (e.g. user.id).
 */
export function trackSignup({ value = 1.0, transactionId } = {}) {
    const payload = {
        send_to: CONVERSIONS.signup,
        value,
        currency: "CAD",
    };
    if (transactionId) payload.transaction_id = transactionId;
    safeGtag("event", "conversion", payload);
}
